export const tabs = {
  sampleTabs: [
    { path: '/tab1', label: 'Tab 1' },
    { path: '/tab2', label: 'Tab 2' },
    { path: '/tab3', label: 'Tab 3' },
  ],
  GEO: [
    { path: '/geo/countries', label: 'Countries' },
    { path: '/geo/provinces', label: 'Provinces' },
    { path: '/geo/district', label: 'Districts' },
    { path: '/geo/analytics', label: 'Analytics' },
  ],
  HOLIDAY: [
    { path: '/settings/options', label: 'Options' },
    { path: '/settings/holiday', label: 'Holiday' },
    { path: '/settings/nationality', label: 'Nationality' },
    { path: '/settings/lecturer-types', label: 'Lecturer Types' },
    { path: '/settings/course-types', label: 'Course Types' },
    
  ],
  SHIFT: [
    { path: '/time-shift/shift', label: 'Shift' },
    { path: '/time-shift/session', label: 'Session' },
  ],
  TERMS: [
    { path: '/terms/semester-term', label: 'Semester' },
    { path: '/terms/accelerated-term', label: 'Accelerated' },
    { path: '/terms/architecture-term', label: 'Architecture' },
  ],
  PROGRAMS: [
    { path: '/education-system/programs', label: 'Programs' },
    { path: '/education-system/degree', label: 'Degree' },
    { path: '/education-system/level', label: 'Level' },
  ],
  CAMPUS: [
    { path: '/campus/rooms', label: 'Rooms' },
    { path: '/campus/building', label: 'Buildings' },
    { path: '/campus/floor', label: 'Floor' },
    { path: '/campus/campus', label: 'Campus' },
    { path: '/campus/room-types', label: 'Room Types' },
  ],
  FACULTY: [
    { path: '/faculties/data', label: 'Data' },
  ],
}
